import React, { useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { Editor as TinyMCEEditor } from 'tinymce';

declare const tinymce: typeof TinyMCEEditor;

type Props = {
  value: string;
  onChange: (value: string) => void;
  className?: string;
};

const environment = {
  tinyapiKey: 'hixnivppcmycafod3g3bpyhyjxor4d74olezgvnhk5fzcb27',
  tinyapiKeyBackup: 'z6t7p21n47pqf8krr37fwoexf9pvt6xak9e33wt19sh1796p',
};

const CKEditorComponent: React.FC<Props> = ({ value, onChange, className = '' }) => {
  const [apiKey, setApiKey] = useState<string>(environment.tinyapiKey);
  const backupKey = environment.tinyapiKeyBackup;

  return (
    <Editor
      textareaName="content"
      value={value}
      //   @ts-ignore
      className={`${className} min-h-[500px]`}
      apiKey={apiKey}
      onEditorChange={(newValue: string) => {
        onChange(newValue);
      }}
      onInit={(_evt, _editor) => {
        console.log('TinyMCE initialized successfully');
      }}

      onError={(error: unknown) => {
        console.error('TinyMCE failed to load:', error);
        if (apiKey !== backupKey) {
          console.warn('Switching to backup TinyMCE API key');
          setApiKey(backupKey);
        }
      }}
      init={{
        height: 650,
        plugins: 'media lists advlist image link align textcolor',
        toolbar: 'media formatselect | styles | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | image | link',
        media_live_embeds: true,
        menubar: false,
        advlist_bullet_styles: ' disc',
        automatic_uploads: true,
        file_picker_types: 'image media',
        file_picker_callback: (cb, value, meta) => {
          const input = document.createElement('input');
          input.type = 'file';

          // 👇 Detect what user clicked
          if (meta.filetype === 'image') {
            input.accept = 'image/*';                 // only images
          } else if (meta.filetype === 'media') {
            input.accept = 'video/mp4,video/webm,video/ogg'; // only videos
          } else {
            input.accept = '*/*';
          }

          input.onchange = function () {
            const file = (this as HTMLInputElement).files?.[0];
            if (!file) return;

            const reader = new FileReader();

            reader.onload = function () {
              const id = 'blobid' + new Date().getTime();
              const base64 = (reader.result as string).split(',')[1];

              // @ts-ignore
              const blobCache = tinymce.activeEditor?.editorUpload.blobCache;
              const blobInfo = blobCache?.create(id, file, base64);
              blobCache?.add(blobInfo);

              if (meta.filetype === 'media') {
                cb(blobInfo?.blobUri() || '', { source2: blobInfo?.blobUri(), poster: '' });
              } else {
                cb(blobInfo?.blobUri() || '', { title: file.name });
              }
            };

            reader.readAsDataURL(file);
          };

          input.click();
        },

      }}
    />
  );
};

export default CKEditorComponent;
